import { makeStyles } from '@material-ui/core';
import { corDaSituacao, FAMILIAS } from 'utils/situacao';

const { texto, solido } = corDaSituacao(FAMILIAS.CONCLUIDO);

export const useStyles = makeStyles(() => ({
  hlConfirm: {
    borderLeft: `2px solid ${texto}`,
    position: 'absolute',
    height: '36px',
    marginLeft: '50px',
    marginTop: 57,
    transform: 'rotate(90deg)',
  },
  isConfirm: {
    borderLeft: `2px solid ${solido}`,
    height: 37,
    position: 'absolute',
    marginLeft: '30px',
    marginTop: -35,
  },
  vlConfirm: {
    borderLeft: `2px solid ${solido}`,
    height: '72px',
    position: 'absolute',
    marginLeft: '30px',
  },
  avatarConfirm: {
    width: '52px',
    height: '52px',
    border: `2px solid ${solido}`,
  },
  iconConfirm: {
    position: 'absolute',
    marginLeft: 26,
    marginTop: 70,
    fontSize: 10,
    color: texto,
    zIndex: 1,
  },
}));
